// extracted by mini-css-extract-plugin
module.exports = {"no_scroll":"FeedPage_no_scroll__3aKUG","feed_container":"FeedPage_feed_container__3rMSJ","write_icon":"FeedPage_write_icon__BUjIt"};